import React from 'react';
import { HomeNavigator } from './HomeNavigator';
import { useSelector } from 'react-redux';
import { View } from 'react-native';
import { Color } from '../styles';
import { createBottomTabNavigator } from '@react-navigation/bottom-tabs';
import { AntDesign } from '@expo/vector-icons';
import BaseText from '../components/BaseText';
import { Stacks } from '../constants/ScreenNames';
import {
  MyTripsNavigator,
  MeNavigator,
  AlertNavigator,
  SocialNavigator,
  ExpenseNavigator,
} from './DrawerStackNavigators';
import Icon from '../components/Icon';
import { AA_ENABLED, TRIPHUB_ENABLED, CREW_ENABLED } from '../config/env';
import { isExpenseAllowed } from '../store/selectors/profile.selector';

const BottomTabNavigator = createBottomTabNavigator();

const BottomIcon = ({ focused, size, name, badget }) => (
  <View>
    <Icon name={name} color={focused ? Color.active : Color.text.medium} size={size} />
    {badget ? (
      <View
        style={{
          position: 'absolute',
          top: -3,
          right: -7,
          backgroundColor: 'red',
          width: 14,
          height: 14,
          borderRadius: 7,
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <BaseText style={{ fontSize: 8, color: 'white' }}>2</BaseText>
      </View>
    ) : null}
  </View>
);

export const BottomTabs = () => {
  const isExpense = useSelector(isExpenseAllowed);
  return (
    <BottomTabNavigator.Navigator
      tabBarOptions={{ showLabel: false }}
      screenOptions={{ headerShown: false }}
    >
      {AA_ENABLED && (
        <BottomTabNavigator.Screen
          name={Stacks.AAHomeStack}
          component={HomeNavigator}
          options={{
            tabBarIcon: () => <AntDesign name="home" size={24} color={Color.text.medium} />,
          }}
        />
      )}

      {CREW_ENABLED ? (
        <BottomTabNavigator.Screen
          name={Stacks.HomeStack}
          component={HomeNavigator}
          options={{
            tabBarIcon: ({ focused, size }) => BottomIcon({ focused, size, name: 'person' }),
          }}
        />
      ) : (
        <BottomTabNavigator.Screen
          name={Stacks.HomeStack}
          component={HomeNavigator}
          options={{
            tabBarIcon: ({ focused, size }) => BottomIcon({ focused, size, name: 'search' }),
          }}
        />
      )}

      <BottomTabNavigator.Screen
        name={Stacks.MytripsStack}
        component={MyTripsNavigator}
        options={{
          tabBarIcon: ({ focused, size }) => BottomIcon({ focused, size, name: 'bag' }),
        }}
      />
      {TRIPHUB_ENABLED ? (
        <BottomTabNavigator.Screen
          name={Stacks.AlertStack}
          component={AlertNavigator}
          options={{
            tabBarIcon: ({ focused, size }) => BottomIcon({ focused, size, name: 'message' }),
          }}
        />
      ) : null}
      {TRIPHUB_ENABLED ? (
        <BottomTabNavigator.Screen
          name={Stacks.SocialStack}
          component={SocialNavigator}
          options={{
            tabBarIcon: ({ focused, size }) => BottomIcon({ focused, size, name: 'people' }),
          }}
        />
      ) : null}
      {isExpense && !CREW_ENABLED ? (
        <BottomTabNavigator.Screen
          name={Stacks.ExpenseStack}
          component={ExpenseNavigator}
          options={{
            tabBarIcon: ({ focused, size }) => BottomIcon({ focused, size, name: 'clip' }),
          }}
        />
      ) : null}
      {!CREW_ENABLED && (
        <BottomTabNavigator.Screen
          name={Stacks.MeStack}
          component={MeNavigator}
          options={{
            tabBarIcon: ({ focused, size }) => BottomIcon({ focused, size, name: 'person' }),
          }}
        />
      )}
    </BottomTabNavigator.Navigator>
  );
};
